export default __webpack_public_path__ + "static/media/SG.78fc2427.svg";